import React from "react";
import {
  WalletModalProvider,
  WalletMultiButton,
} from "@solana/wallet-adapter-react-ui";
import classes from "./Connect.module.css";
import * as anchor from "@project-serum/anchor";

export interface ConnectProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection?: anchor.web3.Connection;
  startDate?: number;
  txTimeout?: number;
  rpcHost?: string;
}

const Connect = (props: ConnectProps) => {
  return (
    <WalletModalProvider>
      <div className={classes["connect-mint-wrapper"]}>
        <WalletMultiButton />
      </div>
    </WalletModalProvider>
  );
};

export default Connect;
